export const whyChoiceUs = [
  {
    label: "সরকার অনুমোদিত ও নিরাপদ:",
    value: "আপনার বিদেশ যাত্রা হবে বৈধ ও নির্ভরযোগ্য",
  },
  {
    label: "বিশ্বস্ত রিক্রুটমেন্ট এজেন্সি:",
    value: "অনুমোদিত এজেন্সির মাধ্যমে নিয়োগের নিশ্চয়তা",
  },
  {
    label: "দক্ষতা উন্নয়নের সুযোগ:",
    value: "আন্তর্জাতিক মানের কোর্স ও প্রশিক্ষণ সুবিধা",
  },
  {
    label: "সহজ ও ব্যবহারবান্ধব:",
    value: "প্রোফাইল তৈরি থেকে চাকরি পাওয়া পর্যন্ত সহজ প্রক্রিয়া",
  },
];

export const howToUse = [
  {
    icon: "/images/how-to-use/1.svg",
    title: "নিবন্ধন",
    description: "সহজ ফর্ম পূরণ করে বিনামূল্যে নিবন্ধন করুন",
  },
  {
    icon: "/images/how-to-use/2.svg",
    title: "প্রশিক্ষণ",
    description: "নির্বাচিত কোর্সে ক্লাস ও অনুশীলন",
  },
  {
    icon: "/images/how-to-use/3.svg",
    title: "অগ্রগতি ট্র্যাক করুন",
    description: "ড্যাশবোর্ডে আপনি কী শিখেছেন এবং সামনে কী আছে তা দেখতে পারবেন",
  },
  {
    icon: "/images/how-to-use/4.svg",
    title: "সার্টিফিকেট",
    description: "সফলদের জন্য সরকারি সার্টিফিকেট",
  },
  {
    icon: "/images/how-to-use/5.svg",
    title: "চাকরি",
    description: "সফলদের জন্য সরকারি সার্টিফিকেট",
  },
];

export const mostUsedJobs = [
  {
    id: 1,
    img: "/images/demo/home/jobs/1.svg",
    title: "মোবাইল সার্ভিস টেকনিশিয়ান",
    description:
      "স্মার্টফোন ও ফিচার ফোনের হার্ডওয়্যার ও সফটওয়্যার সমস্যা চিহ্নিত করে সমাধানের দায়িত্ব",
    companyName: "Al Noor Electricals",
    location: "দুবাই, সংযুক্ত আরব আমিরাত",
    time: "ফুল-টাইম, ৪৮ ঘণ্টা/সপ্তাহ",
    price: "AED ১,৪০০–১,৮০০ / মাস",
    skills: [
      "বেসিক ওয়্যারিং",
      "MCB/DB ইনস্টলেশন",
      "মাল্টিমিটার ব্যবহার ও সেফটি",
    ],
  },
  {
    id: 2,
    img: "/images/demo/home/jobs/2.svg",
    title: "সেলাই মেশিন অপারেটর",
    description:
      "গার্মেন্টস বা ছোট কারখানায় পোশাক তৈরি এবং মেরামতের কাজের জন্য সেলাই মেশিন চালাতে পারা বাধ্যতামূলক",
    companyName: "Al Noor Electricals",
    location: "দুবাই, সংযুক্ত আরব আমিরাত",
    time: "ফুল-টাইম, ৪৮ ঘণ্টা/সপ্তাহ",
    price: "AED ১,৪০০–১,৮০০ / মাস",
    skills: [
      "বেসিক ওয়্যারিং",
      "MCB/DB ইনস্টলেশন",
      "মাল্টিমিটার ব্যবহার ও সেফটি",
    ],
  },
  {
    id: 3,
    img: "/images/demo/home/jobs/3.svg",
    title: "প্লাম্বার (জুনিয়র লেভেল)",
    description:
      "আবাসিক ও বাণিজ্যিক স্থাপনার পানির লাইনের সমস্যা সমাধানে দক্ষতা প্রয়োজন",
    companyName: "Al Noor Electricals",
    location: "দুবাই, সংযুক্ত আরব আমিরাত",
    time: "ফুল-টাইম, ৪৮ ঘণ্টা/সপ্তাহ",
    price: "AED ১,৪০০–১,৮০০ / মাস",
    skills: [
      "বেসিক ওয়্যারিং",
      "MCB/DB ইনস্টলেশন",
      "মাল্টিমিটার ব্যবহার ও সেফটি",
    ],
  },
  {
    id: 4,
    img: "/images/demo/home/jobs/4.svg",
    title: "হাউজ কেয়ারগিভার",
    description:
      "অসুস্থ বা বৃদ্ধ সদস্যদের দেখাশোনা করার জন্য সহানুভূতিশীল ও দায়িত্বশীল প্রার্থী দরকার",
    companyName: "Al Noor Electricals",
    location: "দুবাই, সংযুক্ত আরব আমিরাত",
    time: "ফুল-টাইম, ৪৮ ঘণ্টা/সপ্তাহ",
    price: "AED ১,৪০০–১,৮০০ / মাস",
    skills: [
      "বেসিক ওয়্যারিং",
      "MCB/DB ইনস্টলেশন",
      "মাল্টিমিটার ব্যবহার ও সেফটি",
    ],
  },
  {
    id: 5,
    img: "/images/demo/home/jobs/3.svg",
    title: "প্লাম্বার (জুনিয়র লেভেল)",
    description:
      "আবাসিক ও বাণিজ্যিক স্থাপনার পানির লাইনের সমস্যা সমাধানে দক্ষতা প্রয়োজন",
    companyName: "Al Noor Electricals",
    location: "দুবাই, সংযুক্ত আরব আমিরাত",
    time: "ফুল-টাইম, ৪৮ ঘণ্টা/সপ্তাহ",
    price: "AED ১,৪০০–১,৮০০ / মাস",
    skills: [
      "বেসিক ওয়্যারিং",
      "MCB/DB ইনস্টলেশন",
      "মাল্টিমিটার ব্যবহার ও সেফটি",
    ],
  },
  {
    id: 6,
    img: "/images/demo/home/jobs/6.svg",
    title: "ইলেকট্রিশিয়ান (হাউজিং প্রজেক্ট)",
    description:
      "নতুন বাড়ি ও অফিসে বৈদ্যুতিক তার, সুইচ এবং লাইট ফিটিং-এর কাজ করতে সক্ষম প্রার্থী খোঁজা হচ্ছে",
    companyName: "Al Noor Electricals",
    location: "দুবাই, সংযুক্ত আরব আমিরাত",
    time: "ফুল-টাইম, ৪৮ ঘণ্টা/সপ্তাহ",
    price: "AED ১,৪০০–১,৮০০ / মাস",
    skills: [
      "বেসিক ওয়্যারিং",
      "MCB/DB ইনস্টলেশন",
      "মাল্টিমিটার ব্যবহার ও সেফটি",
    ],
  },
];

export const popularCourse = [
  {
    id: 1,
    img: "/images/demo/home/jobs/4.svg",
    title: "সেলাই ও ড্রেস মেকিং",
    category: "কারিগরি (Vocational)",
    description:
      "কাপড় কাটিং, সেলাই, ডিজাইনিং এবং ছোট ব্যবসা শুরু করার প্রস্তুতি নিয়ে তৈরি এই হস্তশিল্পভিত্তিক কোর্সটি খুবই জনপ্রিয়",
    time: "৭ সপ্তাহ",
    start: "শুরুর স্তর",
    job: "চাকরির উপযোগী",
  },
  {
    id: 2,
    img: "/images/demo/home/jobs/3.svg",
    title: "বেসিক মোবাইল মেরামত",
    category: "কারিগরি (Vocational)",
    description:
      "ক্রেতাদের সহায়তা, পণ্যের ম্যানেজমেন্ট এবং বিলিং পরিচালনা শিখুন। বন্ধুত্বপূর্ণ আচরণ খুব গুরুত্বপূর্ণ",
    time: "৬ সপ্তাহ",
    start: "শুরুর স্তর",
    job: "চাকরির উপযোগী",
  },
  {
    id: 3,
    img: "/images/demo/home/jobs/7.svg",
    title: "প্লাম্বিং কাজের প্রাথমিক ধাপ",
    category: "কারিগরি (Vocational)",
    description:
      "বাড়ি ও অফিসের পানির লাইন, পাইপ ফিটিং, টয়লেট ও বাথরুম ফিটিংসসহ প্লাম্বিংয়ের প্রয়োজনীয় দক্ষতা অর্জনের কোর্স",
    time: "৬ সপ্তাহ",
    start: "শুরুর স্তর",
    job: "চাকরির উপযোগী",
  },
  {
    id: 4,
    img: "/images/demo/home/jobs/4.svg",
    title: "সেলাই ও ড্রেস মেকিং",
    category: "কারিগরি (Vocational)",
    description:
      "কাপড় কাটিং, সেলাই, ডিজাইনিং এবং ছোট ব্যবসা শুরু করার প্রস্তুতি নিয়ে তৈরি এই হস্তশিল্পভিত্তিক কোর্সটি খুবই জনপ্রিয়",
    time: "৭ সপ্তাহ",
    start: "শুরুর স্তর",
    job: "চাকরির উপযোগী",
  },
  {
    id: 5,
    img: "/images/demo/home/jobs/7.svg",
    title: "প্লাম্বিং কাজের প্রাথমিক ধাপ",
    category: "কারিগরি (Vocational)",
    description:
      "বাড়ি ও অফিসের পানির লাইন, পাইপ ফিটিং, টয়লেট ও বাথরুম ফিটিংসসহ প্লাম্বিংয়ের প্রয়োজনীয় দক্ষতা অর্জনের কোর্স",
    time: "৬ সপ্তাহ",
    start: "শুরুর স্তর",
    job: "চাকরির উপযোগী",
  },
  {
    id: 6,
    img: "/images/demo/home/jobs/3.svg",
    title: "বেসিক মোবাইল মেরামত",
    category: "কারিগরি (Vocational)",
    description:
      "ক্রেতাদের সহায়তা, পণ্যের ম্যানেজমেন্ট এবং বিলিং পরিচালনা শিখুন। বন্ধুত্বপূর্ণ আচরণ খুব গুরুত্বপূর্ণ",
    time: "৬ সপ্তাহ",
    start: "শুরুর স্তর",
    job: "চাকরির উপযোগী",
  },
];

export const testimonials = [
  {
    id: 1,
    text: "কোর্সগুলো অনেক সহজভাবে বুঝানো হয়েছে। নতুনদের জন্য খুবই কার্যকর কোর্সগুলো অনেক সহজভাবে বুঝানো হয়েছে। নতুনদের জন্য খুবই কার্যকর",
    name: "সাইফুর রহমান",
    role: "শিক্ষার্থী",
    avatar: "https://i.pravatar.cc/40?img=1",
    rating: 4.5,
  },
  {
    id: 2,
    text: "শিক্ষকদের গাইডলাইন এবং সাপোর্ট অসাধারণ। আমি খুব সন্তুষ্ট",
    name: "মোঃ ইমরান",
    role: "ফ্রিল্যান্সার",
    avatar: "https://i.pravatar.cc/40?img=2",
    rating: 5,
  },
  {
    id: 3,
    text: "প্র্যাকটিক্যাল উদাহরণ থাকায় শেখা অনেক সহজ হয়েছে",
    name: "নুসরাত জাহান",
    role: "স্টুডেন্ট",
    avatar: "https://i.pravatar.cc/40?img=3",
    rating: 4.8,
  },
  {
    id: 4,
    text: "কোর্স কন্টেন্ট খুব সুন্দরভাবে সাজানো",
    name: "রাকিব হাসান",
    role: "ডেভেলপার",
    avatar: "https://i.pravatar.cc/40?img=4",
    rating: 4.6,
  },
  {
    id: 5,
    text: "শিক্ষকদের সাপোর্ট খুব ভালো",
    name: "সাদিয়া ইসলাম",
    role: "ডিজাইনার",
    avatar: "https://i.pravatar.cc/40?img=5",
    rating: 4.7,
  },
  {
    id: 6,
    text: "রিয়েল লাইফ এক্সাম্পল থাকায় কোর্সটি উপকারী",
    name: "তানভীর আহমেদ",
    role: "শিক্ষার্থী",
    avatar: "https://i.pravatar.cc/40?img=6",
    rating: 4.9,
  },
  {
    id: 7,
    text: "ভিডিও টিউটোরিয়ালগুলো খুবই ইন্টারেকটিভ",
    name: "আয়েশা খাতুন",
    role: "ডেভেলপার",
    avatar: "https://i.pravatar.cc/40?img=7",
    rating: 4.4,
  },
  {
    id: 8,
    text: "কোর্স মেটেরিয়াল খুব সহজবোধ্য এবং প্র্যাকটিক্যাল",
    name: "মোঃ শরিফুল",
    role: "ফ্রিল্যান্সার",
    avatar: "https://i.pravatar.cc/40?img=8",
    rating: 4.6,
  },
  {
    id: 9,
    text: "শিখতে খুব মজার এবং প্র্যাকটিক্যাল উদাহরণ দিয়ে সাজানো",
    name: "রুমা আক্তার",
    role: "স্টুডেন্ট",
    avatar: "https://i.pravatar.cc/40?img=9",
    rating: 4.7,
  },
  {
    id: 10,
    text: "টিউটরদের সাপোর্ট এবং কোর্সের কন্টেন্ট অসাধারণ",
    name: "মোঃ হুমায়ূন",
    role: "ডিজাইনার",
    avatar: "https://i.pravatar.cc/40?img=10",
    rating: 4.8,
  },
  {
    id: 11,
    text: "কোর্সটি আমার দক্ষতা অনেক বৃদ্ধি করেছে",
    name: "সুমি রহমান",
    role: "শিক্ষার্থী",
    avatar: "https://i.pravatar.cc/40?img=11",
    rating: 4.9,
  },
  {
    id: 12,
    text: "প্র্যাকটিক্যাল উদাহরণ এবং সহজ ব্যাখ্যা খুবই কার্যকর",
    name: "মোঃ জিয়াদ",
    role: "ফ্রিল্যান্সার",
    avatar: "https://i.pravatar.cc/40?img=12",
    rating: 5,
  },
];
